import { _ } from "libs";

import React from "react";
import PlayerItemMediumCard from "../items/player/mediumCard";
import { MembershipCreatedActivity } from "../../types";
import { formatName } from "../../libs/formatName";
import { openPlayerPopup } from "../../actions";

const MembershipCreated = ({ activities }: { activities: MembershipCreatedActivity[] }) => {
	return activities.length === 0 ? null : (
		<div className="nBlock fixedHeader">
			<h5>
				{_("timeline.newMembers.heading", null, {
					clubName: activities[0].actor.data.name,
				})}
			</h5>
			<div className="newsFeedPlayers">
				{activities.map((activity, index) => {
					return (
						<div
							className="clickable"
							onClick={() => openPlayerPopup(activity.member.data.userId)}
							key={index}
						>
							<PlayerItemMediumCard
								photoUrl={activity.member.data.photoUrl}
								name={formatName(activity.member.data.firstName, activity.member.data.lastName)}
								meta={activity.member.data.rating ? activity.member.data.rating.ITNName : null}
							/>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default MembershipCreated;
